import FileMixin from 'trunks/vue/share/components/fields/file.js';
import FieldMixinForResponse from './mixin.js';
import EsignatureModal from 'trunks/vue/admin/compositions/yet_another_workflow/esignature_modal.js';

const EsignatureForResponse = {
  mixins: [FieldMixinForResponse, FileMixin],

  template: `
    <Field :field='field'
           v-show='visible'
           :extendClass='[fieldCommonClass, fieldDifferenceClass]'
           :message='errorMsg'>
      <template slot='input'>
        <div class="attachments" v-if="value.length">
          <div v-for='(file, index) in value'
               :key='file.id'
               class="attachment-item"
          >
            <div class="attachment-preview-container">
              <div class="attachment-content content-centered">
                <img :src='_thumbnailUrl(value[0])' v-if='value[0]' @click="openEsignatureModal"/>
                <div class="btn icon-btn floated btn-danger btn-small attachment-action delete" v-show='editing' @click.stop='removeFile(index)'>
                  <i class="slp-times"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <button v-else class="btn-default" @click="openEsignatureModal">
          <span>签字</span>
          <i class="slp-pencil-square"></i>
        </button>
        <div class="form-field-value empty-attachments placeholder" v-if='!editing && !value.length'>未填写</div>
      </template>
    </Field>
  `,

  data: function() {
    return {
      esignatureModal: null
    };
  },

  computed: {
    fieldDifferenceClass: function() {
      return {
        'esignature-field': true
      };
    }
  },

  methods: {
    openEsignatureModal: function() {
      if (this.esignatureModal) {
        this.esignatureModal.open();
      } else {
        this.esignatureModal = new EsignatureModal({
          el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('esignature_modal')
        });

        this.esignatureModal.$on('ensureClicked', (value) => {
          this.valueChange(value);
        });
      }
    }
  }
};

export default EsignatureForResponse;
